/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import {
  styled,
  IconButton,
  DialogTitle,
  Typography,
  Checkbox,
  Button,
  Chip,
  DialogContentText,
} from "@mui/material";

export const StyledLastNameLink = styled('a')({
  '&:hover': {
    textDecoration: 'underline !important'
  },
  textDecoration: 'none',
  color: '#348be5',
})

export const StyledIconContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '35px',
})

export const StyledIconButton = styled(IconButton)({
  '&:hover':{
    background: 'transparent !important',
  },
  border: '3px solid #5069c3',
  cursor: 'default',
})

export const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: '600',
  fontSize: '18px',
})

export const StyledConfirmMessage = styled(Typography)({
  paddingTop: '10px',
  fontSize: '15px',
  color: '#535353',
})

export const StyledCheckbox = styled(Checkbox)({
  '&.Mui-checked': {
    color: '#e95420',
  },
  padding: '9px 9px 9px 0px !important'
})

export const StyledConfirmDeleteContainer = styled('div')({
  display: 'flex',
  gap: '5px',
  marginTop: '10px',
})

export const StyledConfirmButton = styled(Button)({
  '&:hover':{
    backgroundColor: " #395bbd !important",
  },
  fontSize: '13px',
  textTransform: 'none',
  backgroundColor: "#395bbd",
  borderRadius: '8px',
  boxShadow: 'none !important',
  fontWeight: '600',
})

export const StyledCancelButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
  fontSize: '13px',
  textTransform: 'none',
  borderRadius: '8px',
  fontWeight: '600',
  color: '#395bbd',
})

export const StyledMfaNotEnrolledChip = styled(Chip)({
  backgroundColor: 'rgba(0, 0, 0, 0.08)',
  color: '#666',
  fontWeight: 500,
  cursor: 'default',
  borderRadius: '999px',
  paddingInline: 8,
});

export const StyledMfaEnrolledChip = styled(Chip)({
  backgroundColor: '#e8f5e9',
  color: '#2e7d32',
  fontWeight: 500,
  cursor: 'default',
  borderRadius: '999px',
  paddingInline: 8,
});

export const StyledMfaEnforcementChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'optional',
})(({ optional }) => ({
  backgroundColor: optional
    ? 'rgba(25, 118, 210, 0.08)'
    : 'rgba(255, 152, 0, 0.1)',
  color: optional ? '#1976d2' : '#ff9800',
  fontWeight: 500,
  borderRadius: '999px',
  paddingInline: 8,
  cursor: 'pointer',
}));

export const StyledDescription = styled(Typography)({
  fontSize: '14px',
  color: '#535353',
  mb: 3,
  lineHeight: 1.6,
})

export const StyledDialogContentText = styled(DialogContentText)({
  fontSize: '15px', 
  color: '#535353',
})

export const StyledSendButton = styled(Button)({
  '&:hover': {
    backgroundColor: 'rgb(206, 231, 254) !important',
    boxShadow: 'none !important',
    color: 'rgb(0, 106, 220) !important',
  },
  fontSize: '0.8125rem',
  textTransform: 'none',
  fontWeight: '400',
  height: '32px',
  borderRadius: '18px',
  width: '120px',
  backgroundColor: 'rgb(206, 231, 254)',
  boxShadow: 'none',
  color: 'rgb(0, 106, 220)',
})
